import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/reducers/reducer';
import DeletingTagWindow from './DeletingTagWindow';
import { tagsGroupModalsActive } from './selectors/group-tag';
import { useDeleteTagGroup } from './services/useDeleteTagGroup';

const DeletingTagGroupModalWrapper = () => {
	const isDeletingTagGroupModalActive = useSelector((
		state: RootState,
	) => tagsGroupModalsActive(state).isDeleteGroupModalActive);

	const { onDeleteGroup, handleDeletingModal } = useDeleteTagGroup();

	return (
		<DeletingTagWindow
			onDelete={onDeleteGroup}
			handleDeletingModal={handleDeletingModal}
			isDeletingModalActive={isDeletingTagGroupModalActive}
			text='Теги из данной группы будут перенесены в категорию "Без группы". Действие нельзя будет отменить.'
		/>
	);
};

export default DeletingTagGroupModalWrapper;
